import React, { useContext, useEffect } from "react";
import Button from "components/shared/Button/Button";
import SimpleGrid, {
  BodyProps,
  CellProps
} from "components/shared/SimpleGrid/SimpleGrid";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "context/Provider";
import { RowInterface } from "context/initialState/Provider";
import { useNavigate } from "react-router";
import { StyledButtonConatiner } from "../../Provider.styles";
import { Grid, Stack } from "@mui/material";

// TODO: needs translation
const ButtonArray = () => {
  const navigate = useNavigate();
  return (
    <StyledButtonConatiner container>
      <Grid item sm={1} md={2} lg={3} xl={5} />
      <Grid item sm={10} md={8} lg={6} xl={4}>
        <Stack spacing={3} direction={"row"}>
          <Button
            variant="primary"
            onClick={() => {
              navigate(`${window.location.pathname}/new`);
            }}
          >
            {"+New Manager"}
          </Button>
          <Button variant="primary" onClick={() => {}}>
            {"+New Organization"}
          </Button>
          <Button variant="primary" onClick={() => {}}>
            {"+Coordinator"}
          </Button>
          <Button variant="primary" onClick={() => {}}>
            {"+Member"}
          </Button>
        </Stack>
      </Grid>
      <Grid item sm={1} md={2} lg={3} xl={3} />
    </StyledButtonConatiner>
  );
};

export default function Managers() {
  const { provider } = useContext(GlobalContext);
  const { t } = useTranslation();
  const keyArray = Object.keys(provider?.organizationList[0]);
  console.log(keyArray);

  const paginationAction = (itemsPerPage?: number, currentPage?: number) => {};

  const header: CellProps[] = [
    { content: "First Name" },
    { content: "Last Name" },
    { content: t("u-email") },
    { content: "Coordinator Access" },
    { content: "Member" }
    // {content: t('u-actions')}
  ];

  // const formatForProvider = (): BodyProps[] =>{
  //     let managerList: RowInterface[] = [];
  //     if(provider) {
  //         // console.log(provider)
  //         managerList = provider.coordinatorList.filter(coord => {
  //             return coord.role === 'Client,Provider' ||  'Client,Owner'
  //         });
  //     }
  //     if(managerList) {
  //         return managerList.map((coord) => {
  //             return {cells: [{content: coord.name.split(' ')[0] || ''}, {content: coord.name.split(' ')[1] || ''}, {content: coord.email || ''}, {content: coord.role === 'Client,Owner' ? '√' : ''}, {content: '√'}]}
  //         })
  //     }else{
  //         return [];
  //     }
  // };

  const generateTable = () => {
    const tablesArr = [];
    for (let i = 0; keyArray.length > i; i++) {
      tablesArr.push(formatForEnterpriseAgent(i));
    }
    return tablesArr.reverse();
  };
  const formatForEnterpriseAgent = (key: number) => {
    const organizationList = Object.values(
      provider?.organizationList[0][keyArray[key]]
    );
    const dressedBody = organizationList.map((user: any) => {
      return {
        cells: [
          { content: user.name.split(" ")[0] || "" },
          { content: user.name.split(" ")[1] || "" },
          { content: user.email || "" },
          { content: user.role === "Client,Owner" ? "√" : "" },
          { content: user.role ? "" : "√" } /*{content: '√'}*/
        ]
      };
    });
    return (
      <div>
        <h4>{keyArray[key]}</h4>
        <SimpleGrid
          headers={header}
          body={dressedBody}
          paginationAction={paginationAction}
        />
      </div>
    );
  };

  return (
    <div>
      <ButtonArray />
      {generateTable()}
    </div>
  );
}
